export default (detail = {}) => {
  const ev = new window.CustomEvent('sms_window:open', { detail })
  window.dispatchEvent(ev)
}
